import type { RouteRecordRaw } from 'vue-router'

// Un unique composant resolveur : depuis le chemin courant, il choisit le bon
// template (accueil, service, article, categorie, page fixe) a partir des JSON locaux.
// Ce catch-all matche aussi '/'. vite-ssg pre-rend chaque chemin enumere par includedRoutes.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: 'resolver',
    component: () => import('@/pages/PageResolver.vue'),
  },
]
